module.exports = __webpack_public_path__ + "img/wh_02.3cf5bba3.png";